import { type ReactNode } from "react";
import { tw } from "~/utilities/styles";

type Props = {
  color?: keyof typeof colorStyles;
  className?: string;
  children: ReactNode;
};

export function Badge({ color = "gray", className, children }: Props) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 font-medium text-xs ${colorStyles[color]} ${className ?? ""}`}
    >
      {children}
    </span>
  );
}

const colorStyles = {
  gray: tw`bg-disabled text-fg`,
  primary: tw`bg-primary/15 text-primary`,
  violet: tw`bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200`,
  green: tw`bg-success/15 text-success`,
  amber: tw`bg-warning/15 text-warning`,
  info: tw`bg-info/15 text-info`,
  error: tw`bg-error/15 text-error`,
};
